module.exports = __webpack_public_path__ + "static/media/campinas-sp.4c4ab1be.jpg";